// src/utils.ts
import { rehype } from "rehype";
var processHtml = (html, plugins = []) => {
  return rehype().data("settings", { fragment: true }).use([...plugins]).processSync(`${html}`).toString();
};
function htmlEncode(sHtml) {
  return sHtml.replace(/```(tsx?|jsx?|html|xml)(.*)\s+([\s\S]*?)(\s.+)?```/g, (str) => {
    return str.replace(
      /[<&"]/g,
      (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" })[c]
    );
  }).replace(
    /[<&"]/g,
    (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" })[c]
  );
}
function stopPropagation(e) {
  e.stopPropagation();
  e.preventDefault();
}

export {
  processHtml,
  htmlEncode,
  stopPropagation
};
//# sourceMappingURL=chunk-ZOV2YOCF.mjs.map